/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Added_To_FavoritesInputs */

const en_added_to_favorites = /** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added to your favorites`)
};

const es_added_to_favorites = /** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadido a tus favoritos`)
};

const fr_added_to_favorites = /** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté à vos favoris`)
};

const de_added_to_favorites = /** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu deinen Favoriten hinzugefügt`)
};

const id_added_to_favorites = /** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditambahkan ke favorit Anda`)
};

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const ja_added_to_favorites = en_added_to_favorites;

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const zh_added_to_favorites = en_added_to_favorites;

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const ar_added_to_favorites = en_added_to_favorites;

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const it_added_to_favorites = en_added_to_favorites;

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const ru_added_to_favorites = en_added_to_favorites;

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const pt_added_to_favorites = en_added_to_favorites;

/** @type {(inputs: Added_To_FavoritesInputs) => LocalizedString} */
const ko_added_to_favorites = en_added_to_favorites;

/**
* | output |
* | --- |
* | "Added to your favorites" |
*
* @param {Added_To_FavoritesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const added_to_favorites = /** @type {((inputs?: Added_To_FavoritesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Added_To_FavoritesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_added_to_favorites(inputs)
	if (locale === "es") return es_added_to_favorites(inputs)
	if (locale === "fr") return fr_added_to_favorites(inputs)
	if (locale === "de") return de_added_to_favorites(inputs)
	if (locale === "ja") return ja_added_to_favorites(inputs)
	if (locale === "zh") return zh_added_to_favorites(inputs)
	if (locale === "ar") return ar_added_to_favorites(inputs)
	if (locale === "id") return id_added_to_favorites(inputs)
	if (locale === "it") return it_added_to_favorites(inputs)
	if (locale === "ru") return ru_added_to_favorites(inputs)
	if (locale === "pt") return pt_added_to_favorites(inputs)
	return ko_added_to_favorites(inputs)
});